<template>
  <a-drawer
    title="缓存管理"
    :width="1440"
    :visible="isShow"
    :body-style="{ paddingBottom: '80px' }"
    @close="handleCancel"
  >
    <div class="pagehead-area">
      <div class="head-area-item">
        <div class="head-area-item__label ant-col-7">页面名称：</div>
        <div class="head-area-item__text">{{ itemData.page_title }}</div>
      </div>
    </div>
    <!-- 搜索 -->
    <a-form :form="detailForm" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="大类">
            <a-select
              v-model="detailForm.data_type_one"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择类型"
              style="width: 100%"
            >
              <a-select-option v-for="item in DATA_TYPE_ONE_ARR" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <div class="operbtnbox">
            <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleClear">重置</a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>
    <!-- 表格 -->
    <a-table row-key="id" :loading="loading" :data-source="data" :pagination="pagination" class="mytable" @change="handleTableChange">
      <a-table-column title="大类" data-index="data_type_one_t" align="center" />
      <a-table-column title="缓存类型" data-index="cache_type_t" align="center" />
      <a-table-column title="缓存概览" :width="300" align="center">
        <template slot-scope="text, record">
          <a-popover trigger="hover">
            <template slot="content">
              <p class="sty-width">{{ record.cache_data }}</p>
            </template>
            <p class="text-overflow-2">{{ record.cache_data }}</p>
          </a-popover>
        </template>
      </a-table-column>
      <a-table-column title="数据来源" data-index="source_type_t" align="center" />
      <a-table-column title="缓存标识" data-index="cache_name" align="center" />
      <a-table-column title="中台标识" align="center">
        <template slot-scope="text, record">
          {{ record.center_slug ? record.center_slug : '-' }}
        </template>
      </a-table-column>
      <a-table-column title="中台生效" :width="300" align="center">
        <template slot-scope="text, record">
          <a-popover trigger="hover">
            <template slot="content">
              <p class="sty-width">{{ record.center_info }}</p>
            </template>
            <p class="text-overflow-2">{{ record.center_info }}</p>
          </a-popover>
        </template>
      </a-table-column>
      <a-table-column title="操作" :width="180" align="center" fixed="right">
        <template slot-scope="text, record">
          <a-button size="small" type="link" @click="cacheSiteClear(record)">清除缓存</a-button>
        </template>
      </a-table-column>
    </a-table>
  </a-drawer>
</template>

<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { detailForm } from '../business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from '../computed/'
import pagination from '@/composables/pagination'
import api from '@/api/'

export default {
  mixins: [dialog],
  props: {
    itemData: {
      type: [Object, Array],
      default() {
        return {}
      },
    }
  },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      detailForm: { ...detailForm }
    })
    onMounted(async () => {
      if (_this.itemData.project) {
        state.detailForm = {
          project: _this.itemData.project,
          type: _this.itemData.type,
          platform_class: _this.itemData.platform_class,
          page_route: _this.itemData.page_route,
          domain: _this.itemData.domain
        }
        methods.getList()
      }
    })
    const methods = {
      search() {
        _this.pagination.current = 1
        methods.getList()
      },
      async getList() {
        _this.loading = true
        const res = await api.cacheSitePageDetail({
          ..._this.detailForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        if (res.code === '000000') {
          const { site, pagination } = res.data
          _this.data = site
          _this.pagination.total = pagination.total
        }
        _this.loading = false
      },
      // 缓存清除
      cacheSiteClear(item) {
        this.$confirm({
          content: '缓存清除后不可恢复，确定要清除吗？',
          okText: "确定",
          cancelText: "取消",
          async onOk() {
            const res = await api.cacheSiteClear({ id: item.id, level: '3' })
            if (_this.$validate(res)) {
              if (res.code === '000000') {
                _this.$message.success('清除成功！')
                methods.getList()
              } else {
                _this.$message.error(res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        _this.isShow = false
      },
      handleClear() {
        state.detailForm.data_type_one = undefined
        this.search()
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>

<style scoped lang="less">
.sty-width {
  width: 600px;
}
.text-overflow-2 {
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
}

/deep/.ant-drawer-body {
  padding: 24px 0;
}
.pagehead-area {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #e8e8e8;

  .head-area-item {
    display: flex;
    align-items: center;
    min-width: 25%;
    line-height: 32px;
    padding: 0px 0 10px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);

    .head-area-item__label {
      text-align: right;
      font-weight: bold;
    }
  }
}

.operbtnbox {
  padding: 4px 0;
}
</style>
